import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import AddGymOffersForm from "../../components/offer-mapping/add-gym-offer/AddGymOffersForm";
import OfferListingTable from "./OfferListingTable";
import { fetchOngoingOffersData } from "../../redux/plans-reducers/plansSlice";
import "../../styles/offers/add-gym-offer.css";
import FilterContainer from "../../components/common-components/filters/filter-container";
import DateRangerFilter from "../../components/common-components/filters/date-ranger-filter";
import SearchFilterWithButton from "../../components/common-components/filters/search-filter-with-button";
import CustomDropDownFilter from "../../components/common-components/filters/CustomDropDownFilter";

const OfferAdding = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { ongoingOffers, ongoingOffersLoading } = useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);


  const iniAllFilter = {
      date_from: "",
      date_to: "",
      search:"",
      status:"",
  }
  const [allFilters, setAllFilters] = useState(iniAllFilter);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: allFilters.status || "",
    search: allFilters.search || "",
    date_from: allFilters.date_from || "",
    date_to: allFilters.date_to || "",
  };

  const [filters, setFilters] = useState(iniFilters);

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getAllOffers = (filterParams) => {
    if (userInfoData?.token) {
      dispatch(fetchOngoingOffersData({ 
        filters: filterParams, 
        token: userInfoData.token 
      }));
    }
  };

  useEffect(() => {
    getAllOffers(filters);
  }, [filters, userInfoData?.token]);

  return (
    <HelmetWrapper title="WTF: Add Offers">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Details Modal"
          ariaHideApp={false}
        >
          <AddGymOffersForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => getAllOffers(filters)}
            isEdit={modValues.modName === "edit"}
            rowData={modValues.rowData}
          />
        </Modal>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Offers"}
              createBtnTxt={"+ Add New"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterContainer onReset={onResetFilters}>
              <DateRangerFilter
                startDate={filters?.date_from}
                endDate={filters?.date_to}
                onDateChange={(startDate, endDate) => {
                  setFilters({ ...filters, date_from: startDate, date_to: endDate });
                }}
              />
              <CustomDropDownFilter
                options={[{ label: "Select Status", value: "" }, ...statusOptions]}
                selectedOption={filters?.status}
                setSelectedOption={(value) => {
                  setFilters({ ...filters, status: value });
                }}
                name={"Status"}
              />
                <SearchFilterWithButton
                selectedSearch={filters?.search}
                setSelectedSearch={(value) => {
                  setFilters({ ...filters, search: value });
                }}
                onSearch={(value) => {
                  setFilters({ ...filters, search: value });
                }}
              />
            </FilterContainer>
          </Col>

        </Row>
        <Row>
          <Col>
            <OfferListingTable
              tableData={ongoingOffers?.data || []}
              pagination={ongoingOffers?.pagination?.[0] || {}}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              loading={ongoingOffersLoading}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getAllOffers(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default OfferAdding;
